import { useCallback, useEffect, useMemo, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import { partnerHistory } from "../GlobalEndpoin";
import toast from "react-hot-toast";
import { Mail, Search } from "react-feather";
import AccountBar from "../../component/AccountBar";
import {
  dateformatYMDDH,
  formatNumberWithout,
  getPartnerName,
} from "../../helper";

const QUICK_RANGES = [
  { key: "today", label: "Hari Ini", days: 1 },
  { key: "7", label: "7 Hari", days: 7 },
  { key: "30", label: "30 Hari", days: 30 },
  { key: "all", label: "Semua", days: 0 },
];

const toInputDate = (date) => date.toISOString().split("T")[0];

const Profile = () => {
  const [dataHistory, setDataHistory] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [activeChip, setActiveChip] = useState("all");
  const [partnerName, setPartnerName] = useState("");
  const navigate = useNavigate();

  const handleGetDataHistory = useCallback(async () => {
    try {
      const res = await partnerHistory({
        token_partnership: secureLocalStorage.getItem("tokenPartner"),
      });
      if (res.status) {
        setDataHistory(res.data);
        setPartnerName(getPartnerName(res));
      } else {
        toast.error("Akun Tidak Dikenali");
        navigate("/not-found");
        secureLocalStorage.removeItem("tokenPartner");
      }
    } catch (error) {}
  }, [navigate]);

  useEffect(() => {
    handleGetDataHistory();
  }, [handleGetDataHistory]);

  const applyQuickRange = (range) => {
    setActiveChip(range.key);
    if (range.key === "all") {
      setFromDate("");
      setToDate("");
      return;
    }
    const today = new Date();
    if (range.key === "today") {
      setFromDate(toInputDate(today));
      setToDate(toInputDate(today));
      return;
    }
    const from = new Date();
    from.setDate(from.getDate() - (range.days - 1));
    setFromDate(toInputDate(from));
    setToDate(toInputDate(today));
  };

  const filteredTx = useMemo(() => {
    const list = (dataHistory?.history_transactions || []).filter(
      (p) => p?.booking !== null
    );
    const q = searchVal.trim().toLowerCase();

    return list.filter((item) => {
      const created = item?.booking?.created_at;
      const d = created ? new Date(created) : null;

      if (fromDate && d) {
        const f = new Date(fromDate);
        f.setHours(0, 0, 0, 0);
        if (d < f) return false;
      }
      if (toDate && d) {
        const t = new Date(toDate);
        t.setHours(23, 59, 59, 999);
        if (d > t) return false;
      }
      if (q) {
        const title = (item?.booking?.event?.title || "").toLowerCase();
        const email = (
          item?.booking?.customer_info?.email || ""
        ).toLowerCase();
        if (!title.includes(q) && !email.includes(q)) return false;
      }
      return true;
    });
  }, [dataHistory, fromDate, toDate, searchVal]);

  const filteredTotal = useMemo(
    () =>
      filteredTx.reduce(
        (sum, item) =>
          sum +
          (item?.booking?.price +
            item?.booking?.tax +
            item?.booking?.internet_fee),
        0
      ),
    [filteredTx]
  );

  const onManualDate = (setter) => (e) => {
    setter(e.target.value);
    setActiveChip("custom");
  };

  return (
    <div className="report-wrap">
      <AccountBar name={partnerName} />
      <h1 className="report-title">Laporan Penjualan</h1>

      <div className="report-stats">
        <div className="report-stat teal">
          <p className="report-stat-label">Total Tiket Terjual</p>
          <p className="report-stat-value">
            {dataHistory?.total_ticket_sell_out || 0} Tiket
          </p>
        </div>
        <div className="report-stat gold">
          <p className="report-stat-label">Total Cash</p>
          <p className="report-stat-value">
            Rp{formatNumberWithout(dataHistory?.total_cash || 0)}
          </p>
        </div>
      </div>

      {dataHistory?.event_total_ticket_sell_out?.length > 0 && (
        <div className="report-panel">
          <h2 className="report-panel-title">Tiket Terjual per Event</h2>
          {dataHistory.event_total_ticket_sell_out.map((item, index) => (
            <div className="report-row" key={index}>
              <span className="report-row-name">{item?.event_name}</span>
              <span className="report-row-qty">{item?.quantity} Tiket</span>
            </div>
          ))}
        </div>
      )}

      <div className="report-panel">
        <h2 className="report-panel-title">Riwayat Transaksi</h2>

        <div className="report-chips">
          {QUICK_RANGES.map((range) => (
            <button
              key={range.key}
              type="button"
              className={`report-chip ${
                activeChip === range.key ? "active" : ""
              }`}
              onClick={() => applyQuickRange(range)}
            >
              {range.label}
            </button>
          ))}
        </div>

        <div className="report-filter-dates">
          <div className="report-field">
            <label>Dari Tanggal</label>
            <input
              type="date"
              value={fromDate}
              max={toDate || undefined}
              onChange={onManualDate(setFromDate)}
            />
          </div>
          <div className="report-field">
            <label>Sampai Tanggal</label>
            <input
              type="date"
              value={toDate}
              min={fromDate || undefined}
              onChange={onManualDate(setToDate)}
            />
          </div>
        </div>

        <div className="home-search" style={{ marginBottom: 4 }}>
          <Search color="var(--primary-color)" size={18} />
          <input
            placeholder="Cari event atau email"
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
          />
        </div>

        <div className="report-filter-summary">
          <span>{filteredTx.length} transaksi</span>
          <span>
            Total: <strong>Rp{formatNumberWithout(filteredTotal)}</strong>
          </span>
        </div>

        {filteredTx.length > 0 ? (
          filteredTx.map((item, index) => (
            <div className="report-tx" key={index}>
              <div className="report-tx-top">
                <span className="report-tx-date">
                  {dateformatYMDDH(item?.booking?.created_at)}
                </span>
                <span className="report-tx-amount">
                  Rp
                  {formatNumberWithout(
                    item?.booking?.price +
                      item?.booking?.tax +
                      item?.booking?.internet_fee
                  )}
                </span>
              </div>
              <p className="report-tx-event">{item?.booking?.event?.title}</p>
              <p className="report-tx-email">
                <Mail size={13} />
                {item?.booking?.customer_info?.email}
              </p>
            </div>
          ))
        ) : (
          <p className="report-empty">Tidak ada transaksi pada rentang ini</p>
        )}
      </div>

      <p className="home-empty" style={{ padding: "8px 0" }}>
        version 0.0.1
      </p>
    </div>
  );
};

export default Profile;
